import { downloadSheet, postForm, postJson } from "./http";

export interface TallyOpeningLedger {
  guid: string;
  name: string;
  kind: "gl" | "bank" | "customer" | "vendor" | "group";
  /** Chart id. Ledgers use the Tally guid; customer-created groups use the group guid. */
  account_id: string;
  /** Set when the parent is a customer-created group. Null when the parent is a reserved group. */
  parent_id: string | null;
  /** Immediate parent name, including a reserved group that was never stored as a row. */
  parent_name: string | null;
  account_type: string | null;
  /** A customer-created group. It has no figure of its own; the ledgers under it do. */
  is_group: boolean;
  tally_amount: number;
  tally_side: "debit" | "credit" | null;
  amount: number;
  side: "debit" | "credit" | null;
  saved: boolean;
  status: string;
  error: string | null;
}

export interface TallyOpeningState {
  ledgers: TallyOpeningLedger[];
  debit_total: number;
  credit_total: number;
  balanced: boolean;
  push: { status: "idle" | "pending" | "failed" | "done"; error: string | null };
}

interface DataEnvelope<T> {
  data: T;
}

const state = (publicId: string) =>
  postJson<DataEnvelope<TallyOpeningState>>("/api/onboarding/tally/opening/state", { public_id: publicId }).then((r) => r.data);

const save = (publicId: string, lines: Array<{ guid: string; debit: number | null; credit: number | null }>) =>
  postJson<DataEnvelope<TallyOpeningState>>("/api/onboarding/tally/opening/save", { public_id: publicId, lines }).then((r) => r.data);

const push = (publicId: string) =>
  postJson<DataEnvelope<TallyOpeningState>>("/api/onboarding/tally/opening/push", { public_id: publicId }).then((r) => r.data);

const template = (publicId: string) =>
  downloadSheet("/api/onboarding/tally/opening/template", { public_id: publicId }, "opening-balances.xlsx");

const upload = async (publicId: string, file: File): Promise<TallyOpeningState> => {
  const form = new FormData();
  form.append("public_id", publicId);
  form.append("file", file);

  return (await postForm<DataEnvelope<TallyOpeningState>>("/api/onboarding/tally/opening/upload", form, ["file"])).data;
};

export const tallyOpeningApi = { state, save, push, template, upload };
